import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';

const CHANGE_EVENT = 'change';

let _venueLocations = [];

let VenueLocationStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    addListener: function(callback) {
        this.addChangeListener(callback);
        return { remove: () => this.removeChangeListener(callback) };
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    getAll: function() {
        return _venueLocations.filter(function(e) { return e !== undefined; });
    },
    getById: function(id) {
        return _venueLocations.find(function(e) { return e !== undefined && e.id == id; });
    },
    getByVenue: function(venueId) {
        return _venueLocations.filter(function(e) { return e !== undefined && e.venueId == venueId; });
    },
    add: function(entity) {
        if (entity !== undefined && !!entity.id && !!entity.venueId) {
            let index = _venueLocations.findIndex(function(e) { return e !== undefined && e.id == entity.id && e.venueId == entity.venueId; });
            if (0 <= index) {
                _venueLocations[index] = entity;
            } else {
                _venueLocations.push(entity);
            }
        }
    },
    remove: function(entity) {
        if (entity !== undefined && !!entity.id && !!entity.venueId) {
            let index = _venueLocations.findIndex(function(e) { return e !== undefined && e.id == entity.id && e.venueId == entity.venueId; });
            if (0 <= index) {
                if (!!entity.deleted) {
                    delete _venueLocations[index];
                } else {
                    _venueLocations[index].loading = undefined;
                }
            }
        }
    },

});

VenueLocationStore.dispatchToken = CentricDispatcher.register(function(action) {

    switch(action.type) {

        case ActionTypes.VENUE_LOCATION_LIST:
            action.data.forEach(VenueLocationStore.add);
            VenueLocationStore.emitChange();
            break;

        case ActionTypes.VENUE_LOCATION_LIST_ERROR:
            VenueLocationStore.emitChange();
            break;

        case ActionTypes.VENUE_LOCATION_INFO:
            VenueLocationStore.add(action.data);
            VenueLocationStore.emitChange();
            break;

        case ActionTypes.VENUE_LOCATION_INFO_ERROR:
            VenueLocationStore.emitChange();
            break;

        case ActionTypes.VENUE_LOCATION_SAVE:
        case ActionTypes.VENUE_LOCATION_UPDATE:
            VenueLocationStore.add(action.data);
            VenueLocationStore.emitChange();
            break;

        case ActionTypes.VENUE_LOCATION_SAVE_ERROR:
        case ActionTypes.VENUE_LOCATION_UPDATE_ERROR:
            // trigger error message
            VenueLocationStore.emitChange();
            break;

        case ActionTypes.VENUE_LOCATION_DELETE:
            VenueLocationStore.remove(action.data);
            VenueLocationStore.emitChange();
            break;

        case ActionTypes.VENUE_LOCATION_DELETE_ERROR:
            VenueLocationStore.emitChange();
            break;

        default:
            break;

    }

});

export default VenueLocationStore;
